/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { FormRow } from "components/CustomComponents/FormRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import { ATCONSTANTS as ATC } from "appconstants";

export function CopyPasteReadElement(props) {
  const { key, value } = props;
  return (
    <div>
      <div>{key}</div>
      <div>{value}</div>
    </div>
  );
}

export function CopyPastePaginateActions(props) {
  const { data, changeEvent, allowReset } = props;
  const [index, setIndex] = useState(1);

  useEffect(() => {
    if (allowReset) {
      setIndex(1);
    }
  }, [data, allowReset]);
  
  const decrement = () => {
    setIndex((arrIndex) => {
      let i = 1;
      if (arrIndex !== 1) {
        i = arrIndex - 1;
      }
      changeEvent(data, i);
      return i;
    });
  };

  const increment = () => {
    setIndex((arrIndex) => {
      let i = data.length;
      if (arrIndex !== data.length) {
        i = arrIndex + 1;
      }
      changeEvent(data, i);
      return i;
    });
  };

  const checkIncrement = () => {
    if (data != null) {
      return index === data.length;
    }
    return true;
  };

  return (
    <div
      style={{ display: "flex", justifyContent: "center" }}
      className="col-12"
    >
      <button
        disabled={index === 1}
        className="fn-btn mr-2"
        type="button"
        onClick={decrement}
      >
        <FontAwesomeIcon
          data-id={`${ATC.EMAIL}LEFT_ARR${ATC.BUTTON}`}
          icon={faChevronLeft}
          className="ml-1"
        />
      </button>
      <span>
        {index}/{data && data.length}
      </span>
      <button
        disabled={checkIncrement()}
        className="fn-btn ml-2"
        type="button"
        onClick={increment}
      >
        <FontAwesomeIcon
          data-id={`${ATC.EMAIL}RIGHT_ARR${ATC.BUTTON}`}
          icon={faChevronRight}
          className="ml-1"
        />
      </button>
    </div>
  );
}

export function CopyPastePaginateElement(props) {
  const { data, input, changeEvent, allowReset } = props;

  return (
    <FormRow
      dataId={`${ATC.APP}${input.id}${ATC.TEXT}`}
      value={input.value}
      label={input.label}
      colSize="col-4"
      colLabel="col-4"
      subColSize="col-4 flex-row-reverse"
      name={input.name}
      readOnly
    >
      {data != null && data.length > 0 && (
        <CopyPastePaginateActions data={data} changeEvent={changeEvent} allowReset={allowReset} />
      )}
    </FormRow>
  );
}
